import React from 'react'

import debounce from 'debounce'

import {
  Input,
  Table,
  Card,
  Tooltip
} from 'antd'

import { _getVipPrices } from '../../../../services'
import moment from 'moment'
import accounting from 'accounting'

class EnterpriseContractProfile extends React.Component {
  state = {
    page: 1,
    searchParam: '',
    pageSize: 10,
    total: 0,
    vipPrices: [],
    customer: {},
    loading: false
  }
  render(){

    const { customer } = this.state

    return (
      <Card style={{ margin: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex' }}>
            <b>Supplier Name: </b>
            <div>{customer.supplierName}</div>
          </div>
          <div style={{ display: 'flex' }}>
            <b>Enterprise Name: </b>
            <div>{customer.enterpriseName}</div>
          </div>
        </div>
        <Input
          placeholder="Search Product"
          style={{width: 400, marginBottom: 16}}
          onChange={this.handleInputChange}
        />
        <Table
          loading={this.state.loading}
          columns={this.getColumns()}
          dataSource={this.state.vipPrices}
          pagination={{
            current: this.state.page,
            pageSize: this.state.pageSize,
            total: this.state.total,
            onChange: (nextPage) => this.setState({ page: nextPage }, this.getVipPrices)
          }}
        />
      </Card>
    )
  }

  componentDidMount() {
    this.getVipPrices()
    this.handleSearch = debounce(this.handleSearch, 400)
  }

  getVipPrices = async () => {

    this.setState({ loading: true }) 

    const {
      page,
      searchParam,
      pageSize
    } = this.state

    const res = await _getVipPrices(searchParam, page, pageSize, this.props.customerId)
    this.setState({ 
      vipPrices: res.data.vipPrices,
      total: res.data.total,
      customer: res.data.customer,
      loading: false
    })
  }

  handleInputChange = (e) => {
    this.handleSearch(e.target.value)
  }

  handleSearch = (searchParam) => {
    this.setState({
      searchParam,
      page: 1
    }, this.getVipPrices)
  }

  getColumns = () => {

    const { vipPrices } = this.state

    let columns = ([{
      title: "Title",
      dataIndex: 'title',
      render: (title, vipPrice) => {
        return (
          <div>
            <div>
              {title}
            </div>
            <div>
              {vipPrice.variants && Object.entries(vipPrice.variants).map(([k,v]) => {
                return (
                  <span style={{
                    fontSize: 12
                  }}>{k} : {v.name}</span>
                )
              })}
            </div>
          </div>
        )
      }
    },{
      title: "MSRP",
      dataIndex: 'price',
      render: (price, vipPrice) => {

        const { variants } = vipPrice

        let _price = price[price.baseCurrency].value;

        if (variants) {
            Object.values(variants).map( variant => {
                _price += variant.price[price.baseCurrency].value
            })
        }

        return accounting.formatMoney(_price, price[price.baseCurrency].symbol, 2)

      }
    },{
      title: "Discount Price",
      dataIndex: 'discountPrice',
      render: (discountPrice) => {
          return discountPrice[discountPrice.baseCurrency].pretty
      }
    },{
      title: "Min. Quantity",
      dataIndex: "minQuantity"
    },{
      title: "Bulk Discount",
      dataIndex: 'bulkDiscount',
      render: (bulkDiscount) => {
        if (!bulkDiscount || bulkDiscount.length == 0) {
          return 
        }

        return (
          <Tooltip title={
            <table>
              <tr>
                <th style={{ padding: "0 12px"}}>Quantity</th>
                <th style={{ padding: "0 12px"}}>Discount</th>
              </tr>
              {bulkDiscount.map( bd => {
                return (
                  <tr>
                    <td style={{ textAlign: 'center'}}>{bd.quantity}</td>
                    <td style={{ textAlign: 'center'}}>{bd.discountValue}% OFF</td>
                  </tr>
                )
              })}
            </table>
          }>
            <a>View</a>
          </Tooltip>
        )
      }
    },{
      title: "Start Date",
      dataIndex: "startDate",
      render: (startDate) => {
        if (!startDate) {
          return 
        }

        return moment(startDate).format("DD/MM/YYYY")
      }
    },{
      title: "Expiry Date",
      dataIndex: "expiryDate",
      render: (expiryDate) => {
        if (!expiryDate) {
          return
        }
        return moment(expiryDate).format("DD/MM/YYYY")
      }
    }])

    // If requireEnterpriseApproval exists
    if (vipPrices.some(_vipPrice => _vipPrice.requireEnterpriseApproval)) {

      columns.push({
        title: "Require Ent Approval",
        dataIndex: "requireEnterpriseApproval",
        render: (requireEnterpriseApproval) => requireEnterpriseApproval ? 'True' : ''
      })

      columns.push({
        title: "Approved By Enterprise",
        dataIndex: "approvedByEnterprise",
        render: (approvedByEnterprise) => approvedByEnterprise ? 'True' : <div style={{color: 'red'}}>False</div>,
      })

    }

    return columns

  }
}

export default EnterpriseContractProfile 


// WEBPACK FOOTER //
// ./src/components/enterprise/contract/profile/index.js